import { Menu, X } from 'lucide-react'
import React, { useContext, useState } from 'react'
import { Outlet } from 'react-router-dom'

import BusinessHeader from '../components/business-component/business-header/BusinessHeader'
import Sidebar from '../components/business-component/business-sidebar/Sidebar'
import Footer from '../components/footer'
import Header from '../components/header'
import { AuthContext } from '@/contexts/auth-context'

function BusinessLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const { auth, loading } = useContext(AuthContext)
  const { authenticate, user } = auth

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return (
    <div className="flex flex-col min-h-[100dvh]">
      {/* Header */}
      <BusinessHeader />

      {/* Changed h-screen to flex-1 here */}
      <div className="flex flex-1">
        {/* TODO : uncomment below code to manage access acc to current plan   */}
        {user &&
          user?.role === 'Business' &&
          user?.subscription &&
          !user?.subscription?.cancelAtPeriodEnd &&
          user?.subscription?.status === 'active' && (
            <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
          )}

        {/* Main content */}
        <main className="flex-1 bg-gray-100 p-4 lg:pt-24 overflow-y-auto">
          <div className="max-w-8xl mx-auto min-h-[calc(100vh-8rem)]">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Footer always sticks to the bottom */}
      <Footer />
    </div>
  )
}

export default BusinessLayout
